import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import TopbarNormal from '../components/topbar/TopbarNormal';
import { CustomBox } from '../components/CustomComp';
import Copyright from '../components/copyright/Copyright';

import theme from '../theme';

const TopBarLayout = (props) => {

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          padding: '10px auto 40px',
          minHeight: '100vh',
        }}>

        <TopbarNormal />
        <CustomBox component="main" sx={{ paddingBottom: theme.spacing(6) }}>
          <Container maxWidth="lg">
            <main>
              {React.cloneElement(props.children)}
            </main>
          </Container>
        </CustomBox>

        <Copyright style={{ color: theme.palette.grey.main }} />

      </Box>
    </>
  );
}

export default TopBarLayout;